import getters from './leadGenGetters'
import actions from './leadGenActions'
import mutations from './leadGenMutations'

const store = {
  namespaced: true,
  state: () => ({
    leadGenQuestions: [],
    answers: {},
    questionFlowData: {},
    orgGuid: null,
    orgType: null,
    settings: {
      loanOfficerTitle: null
    },
    currentQuestionIndex: 0
  }),
  getters,
  actions,
  mutations
}

export default store
